module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/04-043d579eea0b06644cdff6eb26241671.jpg";